module.exports = __webpack_public_path__ + "img/lit_pulsebitcoinlock.2e619c40.png";